import { PrescribedItem } from './../../../../types/prescription'

export const hasUnusualQuantity = (prescribedItem: PrescribedItem): boolean =>
  Boolean(
    (prescribedItem.isPBS || prescribedItem.isRPBS) &&
      (Number(prescribedItem.quantity) > Number(prescribedItem.maximumQuantity) ||
        Number(prescribedItem.numberOfRepeatsAuthorised) > Number(prescribedItem.maximumRepeats))
  )
